import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';

const BASE =
  'block rounded-2xl border border-stone-200 bg-white shadow-sm dark:border-stone-800 dark:bg-stone-900';

/** Scheda (`rounded-2xl`). Con `link` tutta la scheda è un collegamento. */
@Component({
  selector: 'bs-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, RouterLink],
  host: { class: 'block h-full' },
  template: `
    <ng-template #content><ng-content /></ng-template>
    @if (link(); as target) {
      <a
        [routerLink]="target"
        [queryParams]="queryParams() ?? undefined"
        [class]="
          classes() + ' transition-colors hover:border-stone-300 dark:hover:border-stone-600'
        "
        [attr.aria-label]="ariaLabel()"
        [attr.data-testid]="testId()"
      >
        <ng-container [ngTemplateOutlet]="content" />
      </a>
    } @else {
      <div [class]="classes()" [attr.data-testid]="testId()">
        <ng-container [ngTemplateOutlet]="content" />
      </div>
    }
  `,
})
export class CardComponent {
  readonly link = input<string | readonly unknown[] | null>(null);
  readonly queryParams = input<Record<string, string> | null>(null);
  readonly padding = input<'none' | 'md'>('md');
  readonly ariaLabel = input<string | null>(null);
  readonly testId = input<string | null>(null);

  protected readonly classes = computed(
    () => `${BASE} ${this.padding() === 'md' ? 'p-5' : 'overflow-hidden'} h-full`,
  );
}
